import {
  SOLAR_ANNUAL_KWH_PER_KW_BY_REGION,
  SOLAR_ITC_RATE,
  SOLAR_MAX_KW,
  SOLAR_MIN_KW,
  SOLAR_MONTH_WEIGHTS_BY_REGION,
  SOLAR_USD_PER_WATT,
} from './assumptions';
import { consumptionKwhForMonth } from './solarSplit';
import { EnergyLoads, MeasureApplication, SimulationContext } from './types';

export type SolarApplication = MeasureApplication & { sizeKw: number };

export const applySolar = (loads: EnergyLoads, ctx: SimulationContext): SolarApplication => {
  const annualKwhPerKw = SOLAR_ANNUAL_KWH_PER_KW_BY_REGION[ctx.climateRegion];
  const annualConsumptionKwh = loads.baseloadKwh.reduce(
    (total, _, month) => total + consumptionKwhForMonth(loads, month),
    0
  );

  const unclamped = annualConsumptionKwh / annualKwhPerKw;
  const sizeKw = Math.round(Math.min(Math.max(unclamped, SOLAR_MIN_KW), SOLAR_MAX_KW) * 10) / 10;

  const grossUsd = sizeKw * 1000 * SOLAR_USD_PER_WATT;
  const incentiveUsd = grossUsd * SOLAR_ITC_RATE;

  return {
    loads: {
      ...loads,
      solarKwh: SOLAR_MONTH_WEIGHTS_BY_REGION[ctx.climateRegion].map(
        (weight, month) => loads.solarKwh[month] + sizeKw * annualKwhPerKw * weight
      ),
    },
    measureCost: {
      grossUsd,
      incentiveUsd,
      measure: 'SOLAR',
      netUsd: grossUsd - incentiveUsd,
    },
    sizeKw,
  };
};
